'use client';
import React from 'react';
import Slider from 'react-slick';

const TechnicalApproachAiStrategy: React.FC = () => {
    const technicalapproach = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="section-py case-study relative overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="media/video-ai-strategy-consulting.mp4" type="video/mp4" />
                    </video>
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>
                <div className="container lg:container md:mx-auto relative z-[1]">
                    <div className="row grid lg:grid-cols-12 mb-50">
                        <div className="lg:col-span-10">
                            <h2 className="mb-2.5 text-white">
                                How We Build: <span className="gradient-text">Our Technical Approach</span>
                            </h2>
                            <p className="mb-0 fw-600 text-[#D7DEE5]">
                                Our AI strategy consulting process follows a structured, step-by-step methodology designed to align AI capabilities with your business objectives and ensure successful adoption.
                            </p>
                        </div>
                    </div>

                    <div className="section pb-16 case-study-slider-img case-study-slider-aiml technical-approach-slider aienabled-fintech-slider">
                        <div className="container-fluid lg:container-fluid mx-auto">
                            <Slider {...technicalapproach} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-discovery-design bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Discovery & Current State Assessment
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    We begin by understanding your business goals, evaluating existing capabilities, data ecosystems, technology stack, organizational structure, and the competitive environment.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-data-preparation bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    AI Maturity Evaluation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Using industry-standard frameworks, we assess your data infrastructure, technical skillsets, talent readiness, governance models, and cultural preparedness for AI adoption.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-rag-architecture bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                   Opportunity Identification
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    We map key business challenges to AI solutions, prioritize use cases by potential impact and feasibility, and distinguish between quick wins and transformative initiatives.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-prompt-engineering bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Strategy Development
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    We craft a comprehensive, phased AI roadmap inclusive of technology recommendations, resource planning, and clearly defined success metrics aligned to your business KPIs.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-fine-tuning bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Business Case & ROI Modeling
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    We develop detailed financial models covering cost-benefit analysis, risk assessment, investment timelines, and expected returns across prioritized initiatives.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Pilot Design & Validation
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                   We design focused proofs-of-concept with defined success criteria, data requirements, timelines, and resource allocation to validate AI approaches rapidly.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-discovery-design bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Implementation Planning
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                   We prepare detailed execution plans outlining workstreams, dependencies, governance structures, change management, and stakeholder communications for smooth rollout.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-data-preparation bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Delivery & Enablement
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    We provide ongoing advisory support, continuous course correction, executive dashboards, and knowledge transfer to empower your internal teams.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default TechnicalApproachAiStrategy;
